import { MsalAuthProvider, LoginType } from "react-aad-msal";
import getSubdomain from "./getSubdomain";

// Msal Configurations
const config = {
  auth: {
    clientId: "faf4ddfc-5a11-42f9-bfe6-374a60fbc600",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: process.env.NODE_ENV === "development"
      ? "http://localhost:4000/msal/"
      : `https://${getSubdomain()}.culturehq.com/msal/`
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Authentication Parameters
const authenticationParameters = {
  scopes: [
    "openid", "profile", "User.Read"
  ]
};

// Options
const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: `${window.location.origin}/auth.html`
};

const msalConfig = new MsalAuthProvider(config, authenticationParameters, options);

export default msalConfig;
